import axios from '../config/axiosInstance';

export interface TrainingVideo {
    id: string;
    title: string;
    description: string | null;
    youtubeUrl: string;
    category: string | null;
    isPublished: boolean;
    createdAt: string;
}

const trainingLibraryService = {
    async getPublishedVideos(): Promise<TrainingVideo[]> {
        const response = await axios.get('/training-library');
        return response.data;
    },

    async getVideoById(id: string): Promise<TrainingVideo> {
        const response = await axios.get(`/training-library/${id}`);
        return response.data;
    },
};

export default trainingLibraryService;
